module.exports = __webpack_public_path__ + "static/media/review.be972bea.svg";